import styled from "@emotion/styled";
import Button from "@/components/Button";

export const AppListWrapper = styled.div`
	border: solid 1px #e0e0e0;
	border-radius: 4px;
	margin-top: 1.5rem;
`;

export const AppTitleWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	border-bottom: solid 1px #e0e0e0;
	padding: 1.75rem;
`;

export const AppTitleNameWrapper = styled.div`
	display: flex;
	gap: 0.7rem;
	align-items: center;
`;

export const AppTitleName = styled.div`
	font-size: 1.25rem;
`;

export const AppPaymentChangeButton = styled(Button)`
	height: 2.5rem;
`;

export const AppDetailWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-row-gap: 0.8rem;
	padding: 1.75rem;
`;

export const AppDetailContents = styled.div`
	display: flex;
	gap: 3.5rem;
`;

export const AppDetailTitle = styled.div<{ width: string }>`
	width: ${(props) => props.width};
	font-size: 1rem;
	color: #545351;
`;

export const DescriptionUpperTitleImage = styled.div`
	margin-right: 10px;
	width: 34px;
	height: 34px;
	padding: 5px;
	border-radius: 4px;
	background-color: #5292fa;
	display: flex;
	align-items: center;
	justify-content: center;
`;
